import { render } from "./CardFeatures.vue?vue&type=template&id=6d7824e2&scoped=true"
import script from "./CardFeatures.vue?vue&type=script&lang=js"
export * from "./CardFeatures.vue?vue&type=script&lang=js"

import "./CardFeatures.vue?vue&type=style&index=0&id=6d7824e2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6d7824e2"

export default script